import { Form, Input, Tooltip } from "antd";
import { useForm } from "antd/lib/form/Form";
import _ from "lodash";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { DraggableModal } from "../../../../components/DraggableModal";
import { EntDirectoryInfoName } from "../../../../models/directoryInfoName";
import { aliasText } from "../../../../utils";

enum FormField {
    alias,
    nameKy,
    nameRu
}

interface IProps {
    show: boolean;
    animalBreed: EntDirectoryInfoName;
    onHide: () => void;
    onSubmit: (pos: EntDirectoryInfoName) => Promise<boolean>;
}

export const AddAnimalBreedFarmTypeModal = (props: IProps) => {
    const { t } = useTranslation();
    const [form] = useForm();
    const [loading, setLoading] = useState<boolean>(false);


    useEffect(() => {
        if (props.show) setFieldsFromEntity();
    }, [props.show]);


    const setFieldsFromEntity = (): void => {
        form.setFields([
            { name: FormField.alias, value: props.animalBreed.alias },
            { name: FormField.nameKy, value: props.animalBreed.nameKy },
            { name: FormField.nameRu, value: props.animalBreed.nameRu },
        ]);
    }

    const setEntityFromFields = (): EntDirectoryInfoName => {
        let typeFarm = _.cloneDeep(props.animalBreed);
        typeFarm.alias = form.getFieldValue(FormField.alias);
        typeFarm.nameKy = form.getFieldValue(FormField.nameKy);
        typeFarm.nameRu = form.getFieldValue(FormField.nameRu);
        return typeFarm;
    }

    const handleSubmit = async () => {
        setLoading(true);
        try {
            await form.validateFields();
            const data = setEntityFromFields();
            const result = await props.onSubmit(data);

            if (result) props.onHide();
        } finally {
            setLoading(false);
        }
    }

    return (
        <>
            <DraggableModal
                title={props.animalBreed.id === 0 ? t('handbooks.types_of_farms.add_types_of_farms') : t('handbooks.types_of_farms.edit_types_of_farms')}
                visible={props.show}
                onCancel={props.onHide}
                onSubmit={handleSubmit}
                submitLoading={loading}
            >
                <Form
                    initialValues={{ remember: true }}
                    autoComplete="off"
                    layout="vertical"
                    form={form}
                >
                    <Tooltip title={aliasText} >
                        <Form.Item
                          label={t('general.alias')}
                          name={FormField.alias}
                          rules={[{ required: true, message: t("msg.fill_in_the_field") }]}

                        >
                            <Input maxLength={255} showCount autoComplete="off" />
                        </Form.Item>
                    </Tooltip>
                    <Form.Item
                        label={t('general.nameKy')}
                        name={FormField.nameKy}
                        rules={[{ required: true, message: t("msg.fill_in_the_field") }]}
                    >
                        <Input autoComplete="off" />
                    </Form.Item>
                    <Form.Item
                        label={t('general.nameRu')}
                        name={FormField.nameRu}
                        rules={[{ required: true, message: t("msg.fill_in_the_field") }]}
                    >
                        <Input autoComplete="off" />
                    </Form.Item>
                </Form>
            </DraggableModal>

        </>

    )
}
